import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { IProductType } from 'src/app/models/Summary';

export interface ICustomFilter {
    startDate: Date;
    endDate: Date;
}

interface ApiLogState {
    hasfilterApplied: boolean;
    customFilter: ICustomFilter;
}

const initialState: ApiLogState = {
    hasfilterApplied: false,
    customFilter: {
        startDate: moment().toDate(),
        endDate: moment().add(8, 'hours').toDate(),
    },
};

export const apiLogSlice = createSlice({
    name: 'apiLog',
    initialState,
    reducers: {
        setStartDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.startDate = moment(action.payload).toDate();
            state.customFilter.endDate = moment(action.payload).add(8, 'hours').toDate();
        },
        setEndDate: (state, action: PayloadAction<Date | null>) => {
            state.customFilter.endDate = action.payload;
        },
        applyFilter: (state) => {
            state.hasfilterApplied = true;
        },
        clearFilter: (state) => {
            state.hasfilterApplied = false;
            state.customFilter.startDate = moment().toDate();
            state.customFilter.endDate = moment().add(8, 'hours').toDate();
        },
    },
});

export const { setEndDate, setStartDate, applyFilter, clearFilter } = apiLogSlice.actions;
export default apiLogSlice.reducer;
